import { Component, Input, OnChanges } from '@angular/core';
import { ApplicationConstants } from '@ddt-web/models-browsing';

@Component({
	selector: 'me-mini-compare-bar-skeleton',
	templateUrl: './mini-compare-bar-skeleton.component.html',
	styleUrls: ['./mini-compare-bar-skeleton.component.scss']
})
export class MiniCompareBarSkeletonComponent implements OnChanges {

	@Input() public modelsCount: number;
	public skeletonArray: number[];
	public ngOnChanges(): void {
		this.skeletonArray = Array(ApplicationConstants.MAX_MODELS_FOR_COMPARISON - this.modelsCount).fill(0);
	}

}
